<template>
  <div>
    <h2 :id="field.id">{{ field.label[currentLanguage] }}</h2>
    <p class="small" v-if="field.description[currentLanguage]" v-html="field.description[currentLanguage]"></p>
  </div>
</template>

<script>
export default {
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
}
</script>



// WEBPACK FOOTER //
// src/components/elements/step.vue